/* eslint-disable react/no-array-index-key */
import { PropTypes } from 'prop-types';
import React, { useEffect } from 'react';
import { Button } from '@material-ui/core';
import { find } from 'lodash';
import Coasegurado from '../Coasegurado';

const CoaseguradosForm = ({
  parentescos,
  coasegurados,
  setCoaseguradosArray,
  onValidation,
}) => {
  const handleChange = (e, field, index) => {
    const updatedCoasegurados = [...coasegurados];
    updatedCoasegurados[index][field] = e && e.target ? e.target.value : e;
    setCoaseguradosArray(updatedCoasegurados);
  };

  const handleAdd = () => {
    if (coasegurados.length < 8) {
      let updated;
      if (coasegurados.length === 0) {
        updated = [
          {
            nombre: '',
            fechaNacimiento: new Date(),
            parentescoId: '',
          },
        ];
      } else {
        updated = coasegurados.map(b => ({
          ...b,
        }));

        updated.push({
          nombre: '',
          fechaNacimiento: new Date(),
          parentescoId: '',
        });
      }
      setCoaseguradosArray(updated);
    }
  };

  const handleRemove = index => {
    const updated = coasegurados.filter((_, i) => i !== index);
    if (updated.length > 0) {
      const updatedWith = updated.map(b => ({
        ...b,
      }));
      setCoaseguradosArray(updatedWith);
    } else {
      setCoaseguradosArray([]);
    }
  };

  const isValid = () =>
    coasegurados.every(coa => {
      const parentesco = find(parentescos, { id: coa.parentescoId });
      if (parentesco && parentesco.codeName === 'CONYUGE') {
        return coa.nombre && coa.fechaNacimiento && coa.parentescoId;
      }
      if (parentesco && parentesco.codeName === 'HIJO') {
        return (
          coa.nombre &&
          coa.fechaNacimiento &&
          new Date().getFullYear() -
            new Date(coa.fechaNacimiento).getFullYear() <=
            25 &&
          coa.parentescoId
        );
      }

      return false;
    });

  useEffect(() => {
    const isAllValid =
      coasegurados.length > 0 ? coasegurados.every(isValid) : true;
    onValidation(isAllValid);
  }, [coasegurados, onValidation]);

  useEffect(() => {
    setCoaseguradosArray(coasegurados);
  }, [coasegurados, setCoaseguradosArray]);

  return (
    <div className="beneficiarios-form">
      {coasegurados.map((item, index) => (
        <div key={index}>
          <h3 style={{ marginTop: '15px' }}>Coasegurado {index + 1}</h3>
          <Coasegurado
            key={index}
            coasegurado={item}
            parentescos={parentescos}
            onChange={(e, field) => handleChange(e, field, index)}
            onRemove={() => handleRemove(index)}
          />
        </div>
      ))}
      {coasegurados.length < 7 && (
        <Button color="primary" onClick={handleAdd}>
          Agregar Coasegurado
        </Button>
      )}
    </div>
  );
};

CoaseguradosForm.propTypes = {
  parentescos: PropTypes.array,
  coasegurados: PropTypes.array,
  setCoaseguradosArray: PropTypes.func,
  onValidation: PropTypes.func,
};

export default CoaseguradosForm;
